<div class="d-flex align-items-center">
    <div class="d-inline-block p-0 mt-0">
        <input (click)="onClick()" type="checkbox"
               class="form-check-input checkbox-dark-styled"
               [checked]="checkedState"/>
    </div>
    <label class="ms-2" [ngClass]="{'checked': checkedState}">
        {{ label }}
    </label>
</div>
